export default __webpack_public_path__ + "static/media/user-andy.57dafd1c.png";